import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import emailjs from "emailjs-com";
import contactformDesksvg from "../../assets/Homepage/ContactformDesktop.svg";
import buttonarrowactive from "../../assets/Buttonarrow.svg";


// Validation schema
const ContactSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().required("Required"),
  message: Yup.string(),
});

const FooterContact = () => {
  const sendEmail = (values, { resetForm, setSubmitting }) => {
    emailjs
      .send(
        "service_16dxod9", // EmailJS service ID
        "template_0dddk3f", // EmailJS template ID
        {
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.phone,
          email: values.email,
          message: values.message,
        },
        "cqGhcQoxEAW7F74gh" // EmailJS public key
      )
      .then(() => {
        alert("Message sent successfully!");
        resetForm();
        setSubmitting(false);
      })
      .catch((err) => {
        alert("Failed to send message.");
        console.error(err);
        setSubmitting(false);
      });
  };

  return (
    <section
      className="py-12 bg-white"
      style={{ fontFamily: "Garamond, serif" }}
    >
      <div className="max-w-7xl mx-auto section-padding grid md:grid-cols-2 gap-12 items-center">
        {/* Left side */}
        <div>
          <h2
            className="font-garamond-footer-heading font-normal text-[#2C3075] leading-tight mb-10 px-4"
            style={{ color: "#2C3075", fontWeight: "normal"  }}
          >
            The Future of Better Health has Arrived
          </h2>

          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              phone: "",
              message: "",
            }}
            validationSchema={ContactSchema}
            onSubmit={sendEmail}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form
                className="grid grid-cols-1 px-4 md:grid-cols-2 gap-6 max-w-full 
                font-generalsans-description pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] tracking-[0]tracking-normal  text-[14px}"
               
              >
                {/* First Name */}
                <div  className="m-4">
                  <Field
                    name="firstName"
                    placeholder="Your First Name"
                    className="border-b border-gray-400 focus:border-[#2C3075] outline-none pb-1 w-full"
                  />
                  {errors.firstName && touched.firstName && (
                    <div className="text-red-500 text-sm">
                      {errors.firstName}
                    </div>
                  )}
                </div>

                {/* Last Name */}
                <div className="m-4">
                  <Field
                    name="lastName"
                    placeholder="Your Last Name"
                    className="border-b border-gray-400 focus:border-[#2C3075] outline-none pb-1 w-full"
                  />
                  {errors.lastName && touched.lastName && (
                    <div className="text-red-500 text-sm">
                      {errors.lastName}
                    </div>
                  )}
                </div>

                {/* Phone */}
                <div className="m-4">
                  <Field
                    name="phone"
                    placeholder="Your Phone Number"
                    className="border-b border-gray-400 focus:border-[#2C3075] outline-none pb-1 w-full"
                  />
                  {errors.phone && touched.phone && (
                    <div className="text-red-500 text-sm">{errors.phone}</div>
                  )}
                </div>

                {/* email */}
                <div className="m-4">
                  <Field
                    name="email"
                    placeholder="Email (optional)"
                    className="border-b border-gray-400 focus:border-[#2C3075] outline-none pb-1 w-full"
                  />
                  
                </div>

                {/* Message */}
                <div className="md:col-span-2 ml-4 mt-8">
                  <Field
                    
                    name="message"
                    rows="4"
                    placeholder="Message (Optional)"
                    className="border-b border-gray-400 focus:border-[#2C3075] outline-none pb-1 w-full resize-none"
                  />
                </div>

                {/* Submit button */ }
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="md:col-span-2 md:h-14 mt-8 relative bg-[#E6E7F8] text-[#2C3075] rounded-full px-5 py-2 cursor-pointer hover:bg-[#d7d9ea] transition flex items-center justify-between"
                  style={{ minWidth: "110px" }}
                >
                  <span className="font-medium pl-3">
                    {isSubmitting ? "Sending..." : "Submit"}
                  </span>
                  <span className="flex items-center justify-center rounded-full bg-[#2C3075] w-7 h-7 absolute right-2">
                   
                     <img src={buttonarrowactive} alt="arrow" className="w-8 h-8" />
                  </span>
                </button>
              </Form>
            )}
          </Formik>
        </div>

        {/* Right side: Image */}
        <div className="hidden md:flex  justify-center md:justify-end">
          <img
            src={contactformDesksvg}
            alt="Contact Us"
            className="w-max  max-w-md"
            style={{ maxHeight: "600px" }}
          />
        </div>
      </div>
    </section>
  );
};

export default FooterContact;
